/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCheckEstimationExistsModel,
  ICheckEstimationExistsRequest,
  IMappers,
  ICheckEstimationExistsResponse,
  ICheckEstimationExistsResponseError,
  TCheckEstimationExistsResponse,
} from './types';

const defaultConfig: TCheckEstimationExistsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/check-estimation-exists/',
  hostType: 'api',
} as TCheckEstimationExistsModel;

function createCheckEstimationExistsModel(parameters: ICheckEstimationExistsRequest): TCheckEstimationExistsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckEstimationExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICheckEstimationExistsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCheckEstimationExists<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICheckEstimationExistsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCheckEstimationExistsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCheckEstimationExistsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckEstimationExistsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICheckEstimationExistsResponseError);
    }
  }

  return { response, statusCode } as TCheckEstimationExistsResponse;
}

export { defaultConfig, createCheckEstimationExistsModel, fetchCheckEstimationExists };
